import { Component, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { Subscription } from 'rxjs';
import { ScheduleFlag } from '../../../../domain/schedule.model';
import { EntityRole, SystemUser } from '../../../../domain/user.model';
import { ScheduleState } from '../../store/schedule.state';
import { UserState } from '../../store/user.state';

@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {
    user: SystemUser;
    flag: ScheduleFlag;
    subscriptions: Subscription[] = [];

    get readonly() {
        return this.flag.active === false || !this.isSeller;
    }

    get isSeller() {
        return ([EntityRole.WORKER, EntityRole.AGENT, EntityRole.DIRECT_SALES] as EntityRole[]).indexOf(this.user.entityRole) !== -1;
    }

    constructor(private store: Store) {
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.store.select(UserState.getUser).subscribe(user => this.user = user),
            this.store.select(ScheduleState.getFlag).subscribe(flag => this.flag = flag),
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }

}
